// extracted by mini-css-extract-plugin
export var optionGrid = "_2h-7";
export var optionList = "_2h-6";
export var questionsBlock = "_2h-9";
export var spacer = "_2h-5";
export var stepCenteredContent = "_2h-3";
export var stepInner = "_2h-0";
export var stepInnerFullWidth = "_2h-1";
export var stepInnerLockScroll = "_2h-2";
export var stepTransitionFrame = "_2h-4";
export var welcomeBlock = "_2h-8";